import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";

import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";

import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setAreaData } from "../../reducers/Area/areaForm.reducer";

export const areaEntrySchema = Joi.object({
  name: Joi.string().required().messages({
    "string.empty": "Area Name is required.",
  }),
});

export function useLabtestForm() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);

  const labTestEntry = useCallback(
    async (appId, testId) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.labTestAdd(),
          data: {
            appointment_id: appId,
            lab_test_id: testId,
            remark: "",
            status: 1,
            insert_by: null,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (data.status === 200) {
          enqueueSnackbar("Lab Test Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading]
  );

  const labTestUpdate = useCallback(async (appId, testId, id) => {
    if (loading) return;

    setLoading(true);

    try {
      dispatch(showPageLoader());

      const { data } = await apiPost({
        url: Urls.testUpdate(),
        data: {
          id: id,
          appointment_id: appId,
          lab_test_id: testId,
          remark: "",
          status: 2,
          update_by: null,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data?.id) === 36) {
        enqueueSnackbar("Lab Test Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, []);

  return {
    labTestEntry,
    labTestUpdate,
  };
}
